import type { StoredSectorTemplate } from '../api/keycloak-admin/org-config';
import { node } from './seed-templates-military';

/** Create a civilian seed template with built-in metadata */
function seed(
  sector: 'law-enforcement' | 'fire-ems' | 'emergency-management' | 'international-ngo',
  typeName: string,
  suggestedPlugins: string[],
  tree: ReturnType<typeof node>[],
): StoredSectorTemplate {
  const now = new Date().toISOString();
  return {
    id: crypto.randomUUID(),
    sector,
    typeName,
    suggestedPlugins,
    tree,
    builtIn: true,
    createdAt: now,
    updatedAt: now,
  };
}

/** All built-in civilian sector templates */
export function getCivilianSeedTemplates(): StoredSectorTemplate[] {
  return [
    seed('law-enforcement', 'County Sheriff', ['patrol', 'dispatch', 'incident', 'evidence'], [
      node('Patrol Division', 'PAT', 'division', 'operational', [
        node('Station', 'STA', 'station', 'tactical', [], ['patrol', 'dispatch']),
        node('Station', 'STA', 'station', 'tactical', [], ['patrol', 'dispatch']),
        node('Station', 'STA', 'station', 'tactical', [], ['patrol', 'dispatch']),
      ]),
      node('Investigations', 'INV', 'division', 'operational', [
        node('Bureau', 'BUR', 'bureau', 'tactical', [], ['incident', 'evidence']),
      ]),
    ]),

    seed('law-enforcement', 'Municipal PD', ['patrol', 'dispatch', 'incident'], [
      node('Patrol Division', 'PAT', 'division', 'operational', [
        node('Precinct', 'PCT', 'precinct', 'tactical', [], ['patrol', 'dispatch']),
        node('Precinct', 'PCT', 'precinct', 'tactical', [], ['patrol', 'dispatch']),
      ]),
    ]),

    seed('fire-ems', 'Municipal Fire', ['fire-ops', 'ems', 'dispatch', 'incident'], [
      node('Operations', 'OPS', 'division', 'operational', [
        node('Battalion', 'BATT', 'battalion', 'operational', [
          node('Station', 'STA', 'station', 'tactical', [], ['fire-ops', 'dispatch']),
          node('Station', 'STA', 'station', 'tactical', [], ['fire-ops', 'dispatch']),
        ]),
      ]),
      node('EMS Division', 'EMS', 'division', 'operational', [
        node('EMS District', 'DIST', 'district', 'tactical', [], ['ems']),
      ]),
    ]),

    seed('emergency-management', 'County EM', ['incident', 'weather', 'sar', 'analytics'], [
      node('EOC', 'EOC', 'eoc', 'operational', [
        node('Operations Section', 'OPS', 'section', 'tactical', [], ['incident']),
        node('Planning Section', 'PLAN', 'section', 'tactical', [], ['analytics']),
        node('Logistics Section', 'LOG', 'section', 'tactical'),
      ]),
    ]),

    seed('international-ngo', 'NGO', ['incident', 'sar', 'ems', 'weather'], [
      node('Mission', 'MSN', 'mission', 'operational', [
        node('Project', 'PRJ', 'project', 'tactical', [], ['incident', 'ems']),
        node('Project', 'PRJ', 'project', 'tactical', [], ['incident', 'sar']),
      ]),
    ]),
  ];
}
